import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { setLenis, scrollToId } from "@/lib/scroll";
import Navbar from "@/components/Navbar";
import TravelingDot from "@/components/TravelingDot";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ConnectionPoint from "@/components/ConnectionPoint";
import Approach from "@/components/Approach";
import Treatments from "@/components/Treatments";
import Beyond from "@/components/Beyond";
import Testimonials from "@/components/Testimonials";
import Booking from "@/components/Booking";
import Footer from "@/components/Footer";
import ServicesPage from "@/components/ServicesPage";
import AboutPage from "@/components/AboutPage";
import BlogPage from "@/components/BlogPage";
import BlogPost from "@/components/BlogPost";

const HomePage = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) setTimeout(() => scrollToId(hash), 400);
    else window.scrollTo(0, 0);
  }, [hash]);
  return (
    <main>
      <Hero />
      <Marquee />
      <ConnectionPoint />
      <Approach />
      <Treatments />
      <Beyond />
      <Testimonials />
      <Booking />
      <Footer />
    </main>
  );
};

export default function App() {
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const lenis = new Lenis({ lerp: 0.13, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="App bg-ivory font-sans text-walnut">
        <Navbar />
        <TravelingDot />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}
